import Experiments from '@wix/wix-experiments';
import { withExperiments } from '@wix/wix-experiments-react';
import { connect, ConnectedProps } from 'react-redux';
import { compose } from 'redux';
import React from 'react';
import { loadPayPalScript } from '../../actions/loadPayPalScript';
import {
  selectAreResourcesLoaded,
  selectCurrency,
  selectIsPayPalPmAvailable,
  selectPayPalBnCode,
  selectPayPalClientId,
  selectPayPalMerchantId,
} from '../../selectors';
import { withFedopsLogger } from '../Hoc/Fedops/withFedopsLogger';
import { WidgetFedopsLogger } from '../Hoc/Fedops/FedopsProvider';
import { checkPayPalMethodsEligibility } from '../../actions/checkPayPalMethodsEligibility';
import { ResourcesLoaderController } from './controller';

const mapState = (state) => {
  return {
    isPayPalPmAvailable: selectIsPayPalPmAvailable(state),
    clientId: selectPayPalClientId(state),
    merchantId: selectPayPalMerchantId(state),
    bnCode: selectPayPalBnCode(state),
    currency: selectCurrency(state),
    areResourcesLoaded: selectAreResourcesLoaded(state),
  };
};
const mapDispatch = {
  loadPayPalScript,
  checkPayPalMethodsEligibility,
};
const connector = connect(mapState, mapDispatch);
export type Props = ConnectedProps<typeof connector> & {
  fedopsLogger: WidgetFedopsLogger;
  experiments: Experiments;
};
const composeComponent = compose<React.ComponentType>(connector, withFedopsLogger, withExperiments);

export const ResourcesLoader = composeComponent(ResourcesLoaderController);
